export const ENQUIRY_SUBJECT_NEW_POLICY = 'ZAHTJEV_ZA_PONUDOM';
export const ENQUIRY_SUBJECT_RENEWAL = 'OBNOVA_POLICE';
export const ENQUIRY_SUBJECT_INFO = 'INFORMACIJE';
export const ENQUIRY_SUBJECT_OTHER = 'OSTALO';
export const ENQUIRY_SUBJECT_APARTMENT = 'ZAHTJEV_ZA_PONUDOM_HOK_APARTMAN';
export const ENQUIRY_SUBJECT_MOJ_DOM = 'ZAHTJEV_ZA_PONUDOM_MOJ_DOM';
